import { render, staticRenderFns } from "./NewSubscriber.vue?vue&type=template&id=1bfac442&scoped=true"
import script from "./NewSubscriber.vue?vue&type=script&lang=js"
export * from "./NewSubscriber.vue?vue&type=script&lang=js"
import style0 from "./NewSubscriber.vue?vue&type=style&index=0&id=1bfac442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfac442",
  null
  
)

export default component.exports